export const en = {
  'trainerPage.navMine': 'My trainer page',
  'trainerPage.back': 'Trainers',
  'trainerPage.notATrainer': 'Your login is not linked to a trainer here. A manager links it from the trainer roster.',
  'trainerPage.you': 'This is you',
  'trainerPage.about': 'About',
  'trainerPage.noBio': 'No bio yet.',
  'trainerPage.contact': 'Contact',
  'trainerPage.login': 'Login',
  'trainerPage.noLogin': 'No login linked',
  'trainerPage.upcoming': 'Upcoming classes',
  'trainerPage.upcomingHint': 'The next {days} days',
  'trainerPage.upcomingStaffHint': 'The next {days} days. Open a class for its bookings and attendance.',
  'trainerPage.upcomingEmpty': 'No classes in the next two weeks.',
  'trainerPage.weekly': 'Weekly timetable',
  'trainerPage.weeklyEmpty': 'No recurring classes.',
  'trainerPage.minutes': '{minutes} min',
  'trainerPage.results': 'Results',
  'trainerPage.resultsHint': 'Classes held in the last {days} days, cancelled ones left out.',
  'trainerPage.sessions': 'Classes held',
  'trainerPage.attended': 'Attended',
  'trainerPage.noShows': 'No-shows',
  'trainerPage.unmarked': 'Not marked',
  'trainerPage.members': 'Different members',
  'trainerPage.fillRate': 'Fill rate',
  'trainerPage.fillRateHint': '{attended} of {capacity} places',
  'trainerPage.mine': 'You and {name}',
  'trainerPage.mineAttended.one': '{count} class attended',
  'trainerPage.mineAttended.other': '{count} classes attended',
  'trainerPage.mineNever': 'You have not trained with {name} yet.',
  'trainerPage.mineLast': 'Last one on {date}',
  'trainerPage.mineNext': 'Next booked: {date}',
  'trainerPage.employment': 'Employment',
  'trainerPage.position': 'Position',
  'trainerPage.department': 'Department',
  'trainerPage.employmentType': 'Type',
  'trainerPage.startedOn': 'Since',
  'trainerPage.pay': 'Pay',
  'trainerPage.payHidden': 'Shown to payroll only',
  'trainerPage.noPay': 'No pay terms yet',
  'trainerPage.openEmployee': 'Employee record',
  'trainerPage.leave': 'Leave',
  'trainerPage.leaveEmpty': 'No leave coming up.',
  'trainerPage.awards': 'Awards',
  'trainerPage.awardsEmpty': 'No awards yet.',
  'trainerPage.awardsNeedEmployee': 'Awards are given to employees. Add this trainer to the team under Team → Employees to give them one.',
  'trainerPage.scheduleSession': 'Schedule a class',
  'trainerPage.listDescription': 'Meet the coaches and book their classes.',
  'trainerPage.listEmpty': 'The gym has not introduced its trainers yet.',
  'trainerPage.seeClasses': 'See classes',
};

export const ka: Record<keyof typeof en, string> = {
  'trainerPage.navMine': 'ჩემი ტრენერის გვერდი',
  'trainerPage.back': 'ტრენერები',
  'trainerPage.notATrainer': 'თქვენი ანგარიში აქ ტრენერზე არ არის მიბმული. მენეჯერი მას ტრენერების სიიდან მიაბამს.',
  'trainerPage.you': 'ეს თქვენ ხართ',
  'trainerPage.about': 'შესახებ',
  'trainerPage.noBio': 'ბიოგრაფია ჯერ არ არის.',
  'trainerPage.contact': 'კონტაქტი',
  'trainerPage.login': 'ანგარიში',
  'trainerPage.noLogin': 'ანგარიში არ არის მიბმული',
  'trainerPage.upcoming': 'მომდევნო ვარჯიშები',
  'trainerPage.upcomingHint': 'მომდევნო {days} დღე',
  'trainerPage.upcomingStaffHint': 'მომდევნო {days} დღე. გახსენით ვარჯიში ჯავშნებისა და დასწრების სანახავად.',
  'trainerPage.upcomingEmpty': 'მომდევნო ორ კვირაში ვარჯიშები არ არის.',
  'trainerPage.weekly': 'კვირის განრიგი',
  'trainerPage.weeklyEmpty': 'განმეორებადი ვარჯიშები არ არის.',
  'trainerPage.minutes': '{minutes} წთ',
  'trainerPage.results': 'შედეგები',
  'trainerPage.resultsHint': 'ბოლო {days} დღეში ჩატარებული ვარჯიშები, გაუქმებულების გარეშე.',
  'trainerPage.sessions': 'ჩატარებული ვარჯიშები',
  'trainerPage.attended': 'დაესწრო',
  'trainerPage.noShows': 'არ გამოცხადდა',
  'trainerPage.unmarked': 'არ არის მონიშნული',
  'trainerPage.members': 'სხვადასხვა წევრი',
  'trainerPage.fillRate': 'შევსება',
  'trainerPage.fillRateHint': '{capacity} ადგილიდან {attended}',
  'trainerPage.mine': 'თქვენ და {name}',
  'trainerPage.mineAttended.one': '{count} ვარჯიშს დაესწარით',
  'trainerPage.mineAttended.other': '{count} ვარჯიშს დაესწარით',
  'trainerPage.mineNever': '{name}-სთან ჯერ არ გივარჯიშიათ.',
  'trainerPage.mineLast': 'ბოლოს {date}',
  'trainerPage.mineNext': 'შემდეგი ჯავშანი: {date}',
  'trainerPage.employment': 'დასაქმება',
  'trainerPage.position': 'პოზიცია',
  'trainerPage.department': 'განყოფილება',
  'trainerPage.employmentType': 'ტიპი',
  'trainerPage.startedOn': 'დაწყება',
  'trainerPage.pay': 'ანაზღაურება',
  'trainerPage.payHidden': 'ჩანს მხოლოდ ხელფასების ნაწილისთვის',
  'trainerPage.noPay': 'ანაზღაურების პირობები ჯერ არ არის',
  'trainerPage.openEmployee': 'თანამშრომლის ბარათი',
  'trainerPage.leave': 'შვებულება',
  'trainerPage.leaveEmpty': 'დაგეგმილი შვებულება არ არის.',
  'trainerPage.awards': 'ჯილდოები',
  'trainerPage.awardsEmpty': 'ჯილდოები ჯერ არ არის.',
  'trainerPage.awardsNeedEmployee': 'ჯილდო თანამშრომელს გადაეცემა. ჯილდოს გადასაცემად დაამატეთ ეს ტრენერი გუნდში: გუნდი → თანამშრომლები.',
  'trainerPage.scheduleSession': 'ვარჯიშის დაგეგმვა',
  'trainerPage.listDescription': 'გაიცანით ტრენერები და ჩაეწერეთ მათ ვარჯიშებზე.',
  'trainerPage.listEmpty': 'დარბაზს ტრენერები ჯერ არ წარუდგენია.',
  'trainerPage.seeClasses': 'ვარჯიშების ნახვა',
};
